module.exports = __webpack_public_path__ + "img/house_plan04.30fe864b.svg";